import type { Translation } from "./types";

const ar: Translation = {
    errors: {
        network: "خطأ في الاتصال، برجاء المحاولة مرة أخرى",
        tooLarge: "الصور كبيرة جدًا على الرفع، برجاء تجربة صور أصغر",
        unknown: "حدث خطأ ما",
    },
    filesInput: {
        preparing: "جاري تجهيز الصور...",
    },
    actionsBar: {
        filters: "فلترة",
        applyFilters: "طبّق الفلترة",
        clearFilters: "امسح الفلترة",
        cancel: "إلغاء",
    },
    languages: {
        ar: "العربية",
        en: "English",
    },
    home: {
        title: "الرئيسية",
        greetingMorning: "صباح الخير",
        greetingAfternoon: "طاب يومك",
        greetingEvening: "مساء الخير",
        menuLive: "قائمتك متاحة الآن على",
        copyLink: "نسخ الرابط",
        copied: "تم النسخ",
        previewMenu: "معاينة المنيو",
        attentionTitle: "يحتاج انتباهك",
        allGoodTitle: "كل شيء تمام",
        allGoodSubtitle: "لا يوجد ما يحتاج انتباهك الآن",
        days: "يوم",
        statsTitle: "متجرك في لمحة",
        statProducts: "المنتجات",
        statActiveNote: "مفعل",
        statCategories: "التصنيفات",
        statDiscounts: "خصومات جارية",
        statBranches: "الفروع",
        statSlotsNote: "مكان",
        statStaff: "المسؤولين",
        statDaysLeft: "يوم متبقي",
        alertMenuEmpty: "قائمتك لا تحتوي على أي منتجات بعد",
        alertProductsUnpriced: "منتجات بدون سعر",
        alertCategoriesMissing: "لديك منتجات بدون أي تصنيف",
        alertCategoriesEmpty: "تصنيفات فارغة بدون منتجات",
        alertProductsInactive: "منتجات مخفية عن العملاء",
        alertBranchSlotsUnused: "أماكن فروع مدفوعة لم تستخدمها بعد",
        alertBranchesUnconfigured: "فروع لم تكتمل بياناتها",
        alertSubscriptionMissing: "متجرك ليس لديه اشتراك نشط",
        alertSubscriptionPending: "دفعتك في انتظار التأكيد",
        alertSubscriptionPaused: "قائمتك متوقفة — جدد اشتراكك لإعادتها",
        alertSubscriptionGrace: "انتهى اشتراكك، جدده قبل توقف القائمة",
        alertSubscriptionExpiring: "اشتراكك على وشك الانتهاء",
        alertSupportContacted: "فريقنا رد على شكواك",
        retry: "إعادة المحاولة",
    },
    login: {
        title: "أهلا وسهلا",
        subtitle: "ادخل رقم هاتفك للوصول للنظام",
        phonePlaceholder: "ادخل رقم هاتفك",
        acceptTermsBefore: "أوافق على",
        acceptTermsLink: "الشروط والأحكام",
        readPrivacyBefore: "قرأت",
        readPrivacyLink: "سياسة الخصوصية",
        consentRequired: "لازم توافق على الاتنين قبل ما تكمل",
        submitButton: "تسجيل الدخول",
    },
    verifyOtp: {
        title: "رمز التحقق OTP",
        subtitle: "أدخل رمز التحقق المكون من 4 أرقام الذي تم إرساله إلي هاتفك",
        resendLink: "إعادة ارسال الرمز",
        resendHint: "لم أتلق أي رمز.",
        submitButton: "ارسال",
        reEnterPhone: "إعادة ادخال رقم الهاتف",
    },
    completeData: {
        title: "مرحبا بك",
        subtitle: "اكمل بياناتك للاستمتاع بالنظام",
        pictureLabel: "الصورة",
        namePlaceholder: "الاسم الشخصي",
        submitButton: "إنشاء الحساب",
    },
    selectStore: {
        title: "اقتربت من الوصول",
        subtitle: "اختر المتجر الذي تريده او أنشئ جديد",
        selectButton: "اختيار",
        newStoreButton: "متجر جديد",
    },
    slugInfo: {
        storeTitle: "ما هو الاسم المميز؟",
        storeDefinition: "هو رابط متجرك الخاص الغير قابل للتغيير.",
        storeQrNote: "أكواد QR مبنية على هذا الرابط، غير قابل للتغيير.",
        branchTitle: "ما هو رابط الفرع؟",
        branchDefinition: "هو الاسم الذي يفتح قائمة هذا الفرع تحديداً.",
        branchQrNote: "أكواد QR التي تطبعها لهذا الفرع مبنية على هذا الرابط، غير قابل للتغيير.",
        exampleLabel: "مثال",
        exampleCaption: "هذا الجزء أنت من تختاره",
        rulesTitle: "القواعد",
        rules: [
            "حروف إنجليزية صغيرة وأرقام وشرطات ( - ) فقط",
            "يبدأ بحرف",
            "ينتهي بحرف أو رقم",
            "من 3 إلى 30 حرفاً",
            "بدون مسافات أو حروف عربية أو رموز مثل @ # !",
        ],
        button: "تمام",
    },
    createStore: {
        title: "تبقى خطوة واحدة",
        subtitle: "ادخل بيانات متجرك للاستمتاع بالنظام",
        logoLabel: "شعارك",
        nameLabel: "اسم المتجر:",
        slugPlaceholder: "الاسم المميز",
        slugHint: "رابط قائمتك:",
        slugInvalid: "الرابط يبدأ بحرف إنجليزي صغير، ويتكون من 3 إلى 30 حرفاً من الأحرف والأرقام والشرطات، وينتهي بحرف أو رقم",
        taglineLabel: "الجملة التعريفية:",
        typePlaceholder: "نوع المتجر",
        typeCafe: "مقهى",
        typeRestaurant: "مطعم",
        typeBoth: "مقهى ومطعم",
        typeOther: "أخرى",
        submitButton: "إنشاء الحساب",
        languagesTitle: "اختر لغة المتجر والمنيو",
        languagesSubtitle: "اختر اللغات التي سيتم إدخال المنيو بها ويمكنك إضافة لغات أخرى لاحقاً",
        languagesContinue: "متابعة",
        languagesBack: "رجوع",
    },
    menu: {
        categories: "التصنيفات",
        addLabel: "إضافة",
        productCount: "منتج",
        emptyCategoriesTitle: "لا توجد تصنيفات بعد",
        emptyCategoriesSubtitle: "أضف أول تصنيف لقائمتك",
        emptyProductsTitle: "لا توجد منتجات بعد",
        emptyProductsSubtitle: "أضف أول منتج لهذا التصنيف",
        discount: "خصم",
        visibleLabel: "مختفي؟",
        availableLabel: "مفعل؟",
    },
    sortCategories: {
        title: "ترتيب التصنيفات",
        save: "حفظ الترتيب",
        reset: "إعادة",
    },
    sortProducts: {
        title: "ترتيب المنتجات",
        save: "حفظ الترتيب",
        reset: "إعادة",
    },
    formCategory: {
        createTitle: "إضافة تصنيف",
        editTitle: "تعديل التصنيف",
        nameLabel: "الاسم:",
        submitCreate: "إضافة",
        submitEdit: "حفظ التغييرات",
        deleteMessage: "هل تريد حذف هذا التصنيف؟ لن تُحذف المنتجات المرتبطة به.",
        deleteConfirm: "حذف",
        editAction: "تعديل",
        deleteAction: "حذف",
    },
    notFound: {
        title: "الصفحة غير موجودة",
        subtitle: "عذرًا، الصفحة التي تبحث عنها غير موجودة أو تم نقلها",
        backButton: "العودة للرئيسية",
    },
    profilePopup: {
        owner: "مالك",
        staff: "موظف",
        logout: "تسجيل الخروج",
        switchTitle: "الحسابات",
        otherAccounts: "حسابات تانية",
        addAccount: "أضف حساب تاني",
        switchConfirmMessage: "تبدّل لحساب",
        switchConfirmAction: "بدّل الحساب",
        switchCancel: "إلغاء",
        viewProfile: "الملف الشخصي",
    },
    switchStorePopup: {
        createStore: "أنشئ متجر جديد",
    },
    formProduct: {
        createTitle: "إضافة منتج",
        editTitle: "تعديل المنتج",
        nameSection: "الاسم",
        descriptionSection: "الوصف",
        categoriesSection: "التصنيفات",
        categoriesVisibilitySection: "التصنيفات والظهور",
        pricesSection: "الأسعار",
        addPrice: "إضافة سعر",
        priceAmount: "السعر",
        priceLabel: "التسمية",
        showLabel: "إظهار التسمية",
        visibilitySection: "الظهور",
        activeLabel: "نشط",
        activeHint: "هل هو مفعل؟",
        hiddenLabel: "مخفي",
        hiddenHint: "هل هو مختفي؟",
        discountSection: "الخصم",
        discountType: "نوع الخصم",
        discountPercentage: "نسبة مئوية %",
        discountFixed: "مبلغ ثابت",
        discountAmount: "قيمة الخصم",
        pictureSection: "الصورة",
        addPicture: "إضافة صورة",
        takePicture: "صوّر المنتج",
        capturePicturesAction: "صوّر المنتج",
        picturesLimitHint: "8 صور كحد أقصى",
        emptyPrices: "لا توجد أسعار بعد",
        emptyPictures: "لا توجد صور بعد",
        nameRequired: "الاسم مطلوب",
        categoryRequired: "يجب اختيار تصنيف واحد على الأقل",
        editAction: "تعديل",
        deleteAction: "حذف",
        duplicateAction: "نسخ",
        deleteMessage: "هل تريد حذف هذا المنتج؟ لا يمكن التراجع عن هذا الإجراء.",
        deleteConfirm: "حذف",
        cancel: "إلغاء",
        submit: "إضافة",
        submitEdit: "حفظ التغييرات",
    },
    pricePopup: {
        createTitle: "إضافة سعر",
        editTitle: "تعديل السعر",
        save: "حفظ",
        cancel: "إلغاء",
    },
    clients: {
        title: "المسؤولين",
        addLabel: "إضافة",
        emptyTitle: "لا يوجد مسؤولين بعد",
        emptySubtitle: "أضف أول مسؤول للمتجر",
        ownerBadge: "مالك",
        permissionsLabel: "صلاحيات",
        allBranches: "جميع الفروع",
    },
    formClient: {
        createTitle: "إضافة مسؤول",
        editTitle: "تعديل المسؤول",
        editPermissionsTitle: "تعديل الصلاحيات",
        editAction: "تعديل",
        deleteAction: "إزالة",
        deleteMessage: "هل تريد إزالة هذا المسؤول من المتجر؟",
        deleteConfirm: "إزالة",
        basicInfoSection: "المعلومات الأساسية",
        name: "الاسم",
        namePlaceholder: "الاسم الكامل",
        phone: "رقم الهاتف",
        phonePlaceholder: "01xxxxxxxxx",
        genderMale: "ذكر",
        genderFemale: "أنثى",
        accessSection: "الوصول",
        makeOwnerLabel: "صلاحيات المالك",
        makeOwnerHint: "صلاحية كاملة على المتجر",
        permissionsSection: "الصلاحيات",
        modelColumn: "القسم",
        view: "عرض",
        edit: "تعديل",
        branchesSection: "الفروع",
        branchesAll: "جميع الفروع",
        branchesSome: "فروع محددة",
        cancel: "إلغاء",
        submit: "إضافة المسؤول",
        submitEdit: "حفظ التغييرات",
    },
    branches: {
        title: "الفروع",
        purchaseLabel: "شراء فرع جديد",
        infoNote: "الفروع تتيح لك تخصيص المنيو لكل فرع — يمكنك تعطيل منتجات أو تغيير أسعار لكل فرع على حدة.",
        emptyTitle: "لا يوجد فروع",
        emptySubtitle: "لم تقم بإضافة أي فروع حتى الآن",
        slugLabel: "slug",
        addressLabel: "العنوان",
        inActiveLabel: "غير متاح",
        hiddenLabel: "مختفي",
        pricesLabel: "اختلاف سعر",
        resetLabel: "إعادة تعيين",
        detailsLabel: "التفاصيل",
        slotName: "الفرع",
        addBranchData: "إضافة بيانات الفرع",
        unconfiguredNote: "لم يتم إضافة تفاصيل هذا الفرع بعد",
        noOverridesLabel: "لا يوجد تعديلات على منيو الفرع",
        editAction: "تعديل الفرع",
        resetAction: "إعادة التعيين",
        deleteAction: "حذف الفرع",
        deleteConfirmMessage: "سيتم حذف بيانات الفرع نهائياً. مكان الفرع سيبقى محجوزاً في اشتراكك.",
        deleteConfirmLabel: "حذف",
        resetConfirmMessage: "ستتم إزالة جميع تخصيصات هذا الفرع (الأسعار والمنتجات المخفية وغير المتاحة). هل أنت متأكد؟",
        resetConfirmLabel: "إعادة التعيين",
    },
    formBranch: {
        createTitle: "إضافة فرع",
        editTitle: "تعديل الفرع",
        nameLabel: "اسم الفرع",
        slugLabel: "رابط الفرع",
        slugPlaceholder: "maadi",
        slugHint: "يُستخدم في رابط الفرع. الرابط يبدأ بحرف إنجليزي صغير، ويتكون من 3 إلى 30 حرفاً من الأحرف والأرقام والشرطات، وينتهي بحرف أو رقم",
        addressLabel: "العنوان (اختياري)",
        submit: "حفظ",
        submitEdit: "حفظ التغييرات",
        mapsUrlPlaceholder: "https://maps.app.goo.gl/...",
        mapsUrlHint: "الصق رابط المشاركة من خرائط جوجل عشان العملاء يوصلوا للفرع",
        addressPlaceholders: {
            ar: "شارع 9، المعادي، القاهرة",
            en: "Street 9, Maadi, Cairo",
        },
    },
    support: {
        title: "الشكاوى والاقتراحات",
        addLabel: "شكوى جديدة",
        infoNote: "اكتب لنا أي مشكلة أو اقتراح وسيتواصل معك فريقنا على رقم هاتفك. يمكنك حذف الشكوى بعد حل مشكلتك.",
        emptyTitle: "لا توجد شكاوى",
        emptySubtitle: "افتح شكوى جديدة وسيتواصل معك فريقنا",
        loading: "جاري تحميل الشكاوى…",
        statusPending: "قيد المراجعة",
        statusContacted: "تم التواصل معك",
        statusSolved: "تم الحل",
        readMore: "عرض المزيد",
        readLess: "عرض أقل",
        deleteAction: "حذف الشكوى",
        deleteMessage: "حذف هذه الشكوى؟ لن تظهر لك مرة أخرى في قائمتك.",
        deleteConfirm: "حذف",
    },
    formSupport: {
        createTitle: "شكوى جديدة",
        titleSection: "الموضوع",
        titlePlaceholder: "باختصار، ما هي المشكلة؟",
        messageSection: "التفاصيل",
        messagePlaceholder: "اشرح المشكلة بالتفصيل حتى نتمكن من مساعدتك بشكل أسرع",
        contactNote: "سيتواصل معك فريقنا على رقم هاتف حسابك.",
        cancel: "إلغاء",
        submit: "إرسال الشكوى",
    },
    bottomBar: {
        more: "المزيد",
        close: "إغلاق",
    },
    previewMenu: {
        title: "معاينة المنيو",
        loading: "جاري تحميل المنيو...",
    },
    menuEditor: {
        reorder: "إعادة الترتيب",
        saveBeforeReorder: "احفظ تغييراتك قبل إعادة الترتيب",
        price: "السعر",
        priceLabel: "التسمية",
        title: "محرر المنيو",
        prices: "الأسعار",
        pricesOf: "قائمة الأسعار",
        noPricesYet: "لا يوجد سعر بعد",
        addPrice: "إضافة سعر",
        showLabel: "إظهار الاسم",
        discount: "الخصم",
        noDiscount: "بدون",
        discountOn: "الخصم مفعل",
        discountOff: "بدون خصم",
        discountPercentage: "نسبة",
        discountFixed: "مبلغ ثابت",
        discountAmount: "القيمة",
        fixRowsFirst: "بعض الصفوف تحتاج اسماً، والمنتجات تحتاج تصنيفاً",
        categories: "التصنيفات",
        products: "المنتجات",
        categoriesOf: "تصنيفات المنتج",
        noCategoriesYet: "أضف تصنيفاً أولاً",
        active: "مفعل",
        hidden: "مخفي",
        pickCategories: "اختر",
        filterByCategories: "فلترة بالفئات",
        clearFilter: "إلغاء الفلترة",
        noRowsForFilter: "مفيش منتجات في الفئات المختارة",
        addRow: "صف جديد",
        discard: "تراجع",
        save: "حفظ",
        loading: "جاري تحميل المنيو...",
        retry: "إعادة المحاولة",
        newBadge: "جديد",
        rowTools: "إجراءات الصف",
        revertRow: "تراجع عن هذا الصف",
        removeRow: "حذف هذا الصف",
        cancel: "إلغاء",
        done: "تم",
        nameColumn: "الاسم",
        descColumn: "الوصف",
    },
    sideBar: {
        home: "الرئيسية",
        menu: "المنيو",
        branches: "الفروع",
        orders: "الطلبات",
        clients: "المسؤولين",
        subscriptions: "الاشتراك",
        settings: "الإعدادات",
        support: "الشكاوى والاقتراحات",
        profile: "الملف الشخصي",
    },
    branchMenu: {
        activeHereLabel: "مفعل هنا؟",
        hiddenHereLabel: "مختفي هنا؟",
        previewMenuLabel: "معاينة المنيو",
        configureLabel: "إعداد من الاشتراك",
        configureNote: "لم يتم إعداد هذا الفرع بعد",
        resetLabel: "إعادة تعيين",
        editForBranchLabel: "تعديل لهذا الفرع",
        resetProductLabel: "إعادة تعيين المنتج",
        settingsTitle: "إعدادات الفرع",
        saveLabel: "حفظ",
        cancelLabel: "إلغاء",
        priceHiddenBadge: "مخفي هنا",
        labelHiddenBadge: "التسمية مخفية",
        discountRemovedBadge: "الخصم محذوف هنا",
        changedCountLabel: "متغير",
        viewChangesLabel: "عرض الفروقات",
        diffTitle: "تغييرات الفرع",
        diffNoChanges: "لا توجد تغييرات لهذا المنتج في هذا الفرع",
        diffInactiveLabel: "غير متاح هنا",
        editPricesTitle: "تعديل أسعار الفرع",
        originalPriceLabel: "السعر الأساسي",
    },
    branchAddon: {
        title: "إضافة فروع",
        subtitle: "أضف فروع جديدة لاشتراكك الحالي",
        currentPlanLabel: "الاشتراك الحالي",
        branchesLabel: "الفروع الحالية",
        endsLabel: "ينتهي في",
        comingPlanLabel: "التجديد القادم",
        branchCountLabel: "عدد الفروع للإضافة",
        activeAmountLabel: "الاشتراك الحالي (نسبي)",
        comingAmountLabel: "التجديد القادم",
        totalLabel: "الإجمالي",
        egp: "ج.م",
        submitButton: "تأكيد الطلب",
        amountLabel: "المبلغ المطلوب",
        paymentSubtitle: "حوّل المبلغ لأي طريقة من الطرق التالية، ثم أرسل إيصال التحويل مع رابط متجرك عبر واتساب",
        sendReceiptButton: "إرسال الإيصال عبر واتساب",
        successNote: "سيتم مراجعة إيصالك وتفعيل الفروع خلال أقل من يوم",
        copyPhone: "نسخ",
        copied: "تم",
        addBranchesButton: "إضافة فروع",
        pendingAddonNote: "يوجد طلب إضافة فروع قيد المراجعة",
        pendingAddonTitle: "طلب إضافة فروع",
        payNowButton: "تفاصيل الدفع",
        requestedAtLabel: "تاريخ الطلب",
        storeSlugLabel: "رابط متجرك",
        storeSlugNote: "أرسل هذا الرابط مع الإيصال حتى نتعرف على متجرك",
    },
    subscriptions: {
        title: "الاشتراك",
        statusActive: "نشط",
        statusGrace: "فترة السماح",
        statusPaused: "موقوف",
        statusPending: "في انتظار التفعيل",
        statusComing: "تجديد قادم",
        periodMonthly: "شهري",
        periodQuarterly: "ربع سنوي",
        periodAnnually: "سنوي",
        perMonth: "/ شهر",
        perQuarter: "/ 3 أشهر",
        perYear: "/ سنة",
        choosePlanTitle: "ابدأ مع منيوكيت",
        choosePlanSubtitle: "اختر باقتك وابدأ رحلتك الآن",
        saveLabel: "وفر",
        couponLabel: "كود الخصم",
        couponPlaceholder: "اكتب كود الخصم (اختياري)",
        couponApply: "تطبيق",
        couponRemove: "إزالة",
        couponSavedLabel: "وفّرت",
        couponDiscountLabel: "الخصم",
        payWindowTitle: "ادفع خلال يومين",
        payWindowNote: "ابعت إيصال التحويل قبل {date}. بعد كده الطلب هيتلغى تلقائياً وهتحتاج تبدأ من جديد.",
        totalLabel: "الإجمالي",
        egp: "ج.م",
        subscribeButton: "اشترك الآن",
        branchCount: "فرع",
        branchesLabel: "عدد الفروع",
        branchAddonLabel: "للفرع الإضافي",
        periodLabel: "الباقة",
        pendingTitle: "في انتظار التفعيل",
        pendingSubtitle: "حوّل المبلغ لأي طريقة من الطرق التالية، ثم أرسل إيصال التحويل مع رابط متجرك عبر واتساب",
        storeSlugLabel: "رابط متجرك",
        storeSlugNote: "أرسل هذا الرابط مع الإيصال حتى نتعرف على متجرك",
        amountLabel: "المبلغ المطلوب",
        copyPhone: "نسخ",
        copied: "تم",
        sendReceiptButton: "إرسال الإيصال عبر واتساب",
        pendingNote: "سيتم مراجعة إيصالك وتفعيل اشتراكك خلال أقل من يوم",
        currentPlanTitle: "الاشتراك الحالي",
        startDateLabel: "بدأ في",
        endDateLabel: "ينتهي في",
        daysLeft: "يوم متبقي",
        renewButton: "تجديد الاشتراك",
        comingTitle: "تجديد قادم",
        comingNote: "سيتم تفعيله تلقائياً عند انتهاء اشتراكك الحالي",
        graceTitle: "اشتراكك انتهى!",
        graceNote: "لديك فقط",
        graceDays: "أيام للتجديد أو ستُغلق قائمتك نهائياً",
        renewNow: "جدد الآن",
        pausedTitle: "قائمتك موقوفة",
        pausedNote: "العملاء لا يستطيعون رؤية قائمتك حالياً",
        reactivate: "أعد تفعيل الاشتراك",
        pendingRenewalTitle: "طلب التجديد قيد المراجعة",
        pendingRenewalNote: "سيتم تفعيل تجديدك بمجرد مراجعة إيصال التحويل",
        planPrice: "قيمة الاشتراك",
        comingStartLabel: "سيبدأ في",
        comingEndLabel: "سيمتد حتى",
        graceDaysLabel: "أيام متبقية",
        graceEndedLabel: "انتهى اشتراكك في",
        graceOffLabel: "ستُغلق القائمة في",
        branchConfigButton: "إعداد الفروع",
        branchConfigTitle: "إعداد الفروع",
        confirmTitle: "تأكيد الاشتراك",
        confirmSubtitle: "راجع تفاصيل اشتراكك قبل إنشائه.",
        confirmExtraBranchesLabel: "الفروع الإضافية",
        confirmPaymentTitle: "طريقة الدفع",
        confirmPaymentNote:
            "بعد التأكيد يتم إنشاء اشتراك في انتظار التفعيل، ثم تحوّل المبلغ عبر انستاباي أو ماي فوري أو فودافون كاش وترسل إيصال التحويل على واتساب — ونقوم بتفعيله خلال أقل من يوم.",
        confirmSubmitButton: "أفهم ذالك",
        confirmCancelButton: "إلغاء",
    },
    profile: {
        title: "الملف الشخصي",
        ownerBadge: "مالك المتجر",
        staffBadge: "موظف",
        phoneLabel: "رقم الهاتف",
        genderLabel: "النوع",
        genderMale: "ذكر",
        genderFemale: "أنثى",
        genderUnknown: "غير محدد",
        editProfileAction: "تعديل البيانات",
        otherStores: "متاجر تانية",
        switchStoreAction: "افتح المتجر",
        switchStoreConfirmMessage: "تبدّل للمتجر",
        switchStoreConfirmAction: "بدّل المتجر",
        storesTitle: "المتاجر اللي معاك",
        storesSubtitle: "كل متجر ليك فيه صلاحيات مختلفة",
        activeStoreBadge: "المتجر الحالي",
        permissionsCount: "صلاحية",
        ownerFullAccess: "صلاحية كاملة",
        permissionsTitle: "صلاحياتك في المتجر الحالي",
        permissionsSubtitle: "اللي تقدر تعمله هنا",
        noPermissions: "مفيش صلاحيات في المتجر ده",
        branchesTitle: "الفروع اللي تقدر توصلها",
        branchesSubtitle: "نطاق شغلك في المتجر ده",
        allBranches: "كل الفروع",
        noBranches: "مفيش فروع محددة ليك",
        actionView: "عرض",
        actionEdit: "تعديل",
        logoutTitle: "الحساب",
        logoutAction: "تسجيل الخروج",
        logoutConfirmMessage: "متأكد إنك عايز تخرج من الحساب ده؟ هتحتاج كود تحقق جديد عشان ترجع تاني.",
        logoutConfirmAction: "أيوة، سجل خروجي",
        logoutCancel: "إلغاء",
        logoutSwitchHint: "أو بدّل لحساب تاني من غير ما تخرج:",
        logoutAddAccount: "أضف حساب تاني بدل الخروج",
    },
    qrCodes: {
        title: "أكواد QR",
        subtitle: "اطبعها مرة، والعب بالمنيو على راحتك",
        closeAction: "إغلاق",
        storeTarget: "المنيو الرئيسي",
        noBranches: "مفيش فروع لسه — الكود ده بيفتح المنيو الرئيسي",
        noStore: "اختار متجر الأول عشان تجيب كود الـ QR بتاعه",
        styleClassic: "كلاسيك",
        styleRounded: "مدوّر",
        styleDots: "نقط",
        styleLeaf: "ورقة",
        copyAction: "انسخ اللينك",
        downloadLabel: "تحميل",
        formatHint: "SVG للطباعة بأي مقاس من غير ما تبوظ.",
    },
    orders: {
        title: "الطلبات",
        emptyTitle: "لا توجد طلبات بعد",
        emptySubtitle: "الطلبات اللي عملاؤك هيبعتوها من المنيو هتظهر هنا",
        filterAll: "الكل",
        orderNumber: "طلب",
        itemsCount: "صنف",
        totalLabel: "الاجمالي",
        tableLabel: "طاولة",
        addressLabel: "العنوان",
        branchLabel: "الفرع",
        mainMenu: "المنيو الرئيسي",
        callCustomer: "اتصل بالعميل",
        confirmLabel: "تأكيد",
        rejectLabel: "رفض",
        cancelLabel: "إلغاء الطلب",
        editTitle: "تعديل الطلب",
        editLabel: "تعديل",
        editPrompt: "تحفظ التعديلات دي على الطلب #{number}؟",
        editConfirmLabel: "احفظ التعديلات",
        editSaveLabel: "حفظ",
        editSavingLabel: "جاري الحفظ...",
        editCancelLabel: "إلغاء",
        editNote: "عنوان التوصيل بيتحفظ لو حوّلت الطلب لاستلام أو طاولة، عشان تقدر ترجّعه من غير ما تكتبه تاني.",
        editedBadge: "متعدّل",
        itemsTitle: "الأصناف",
        addItemLabel: "إضافة صنف",
        removeItemLabel: "حذف الصنف",
        itemsRequired: "لازم الطلب يفضل فيه صنف واحد على الأقل",
        estimateLabel: "الاجمالي التقديري",
        itemsNote: "الأسعار بتتحسب من المنيو وقت الحفظ، فالاجمالي فوق تقديري لحد ما تحفظ.",
        pickItemTitle: "اختار من المنيو",
        pickItemSearch: "ابحث باسم المنتج",
        pickItemLoading: "جاري تحميل المنيو...",
        pickItemEmpty: "مفيش منتجات مطابقة",
        pickItemDone: "تمام",
        pickedCount: "{count} صنف",
        newTitle: "طلب جديد",
        createLabel: "سجّل الطلب",
        statusLabel: "حالة الطلب",
        progressTitle: "وصل لفين",
        progressHint: "اضغط على أي خطوة عشان تنقل الطلب لها",
        customerTitle: "العميل",
        returningBadge: "عميل قديم",
        itemsFrom: "أصناف من {menu}",
        copyPhone: "نسخ",
        copiedPhone: "تم النسخ",
        callPhone: "اتصال",
        whatsappPhone: "واتساب",
        branchAll: "كل المنيوهات",
        searchNumber: "رقم الطلب",
        searchPhone: "رقم الهاتف",
        appliedTitle: "فلترة بـ",
        filterStatusLabel: "الحالة",
        filterBranchLabel: "المنيو",
        filterDateLabel: "الوقت",
        clearFiltersLabel: "امسح الفلترة",
        clearFiltersPrompt: "تمسح كل الفلاتر وترجع لكل الطلبات؟",
        clearFiltersConfirm: "امسحها",
        firstOrderLabel: "أول طلب معانا",
        spentLabel: "صرف معانا",
        acrossOrders: "في {count} طلب",
        editedNote: "الطلب اتعدّل {count} مرة بعد ما اتبعت",
        moreItems: "+{count} صنف تاني",
        moreActions: "إجراءات",
        previewLabel: "افتح الطلب",
        /* --- الطلبات الجديدة والتحديثات اللي جاية من غير تحديث للصفحة --- */
        liveLabel: "مباشر",
        liveOffLabel: "مش مباشر",
        liveOnHint: "بنسمع الطلبات الجديدة وبنقولك عليها",
        liveOffHint: "مش بنسمع حاجة، القائمة بتتحدّث لما تحدّثها بنفسك",
        newOrdersOne: "فيه طلب جديد",
        newOrdersMany: "فيه {count} طلبات جديدة",
        newOrdersUnknown: "ممكن يكون فيه طلبات جديدة",
        changedNote: "وفيه طلبات اتغيّرت",
        refreshLabel: "تحديث",
        dismissLabel: "إخفاء",
        changedBadge: "اتغيّر",
        changedHint: "الطلب ده خرج من الفلترة بعد ما اتغيّر — حدّث القائمة",
        soundPrompt: "نشغّل صوت مع كل طلب جديد؟ ده بيساعد لو الشاشة بعيدة عنك.",
        soundConfirm: "شغّل الصوت",
        soundDecline: "من غير صوت",
        soundOnHint: "الصوت شغّال مع الطلبات الجديدة",
        soundOffHint: "الصوت مقفول — دوس تشغّله",
        dateAll: "كل الأوقات",
        dateToday: "النهاردة",
        dateWeek: "آخر أسبوع",
        dateMonth: "آخر شهر",
        dateYear: "آخر سنة",
        searchPlaceholder: "رقم الطلب أو رقم الهاتف",
        statusAll: "كل الحالات",
        phoneLabel: "رقم الهاتف",
        typeLabel: "نوع الطلب",
        movePrompt: 'تنقل الطلب ده لـ "{status}"؟',
        moveLabel: "انقل",
        backPrompt: 'ترجّع الطلب ده لـ "{status}"؟',
        backLabel: "رجوع",
        confirmPrompt: "تأكيد هذا الطلب؟",
        rejectPrompt: "رفض هذا الطلب؟",
        cancelPrompt: "إلغاء هذا الطلب؟",
        loadMore: "تحميل المزيد",
        status: {
            pending: "جديد",
            confirmed: "مؤكد",
            preparing: "بيتجهز",
            ready: "جاهز",
            delivering: "في الطريق",
            completed: "تم",
            rejected: "مرفوض",
            cancelled: "ملغي",
        },
        type: {
            delivery: "توصيل",
            table: "على الطاولة",
            pickup: "استلام من الفرع",
        },
    },
    settings: {
        tabs: {
            storeDetails: "بيانات المتجر",
            contact: "التواصل والروابط",
            ordering: "الطلبات أونلاين",
            menu: "إعدادات المنيو",
        },
        accountTitle: "بياناتك الشخصية",
        accountSubtitle: "دي بياناتك انت، مش بيانات المتجر",
        pictureLabel: "الصورة الشخصية",
        changePicture: "تغيير الصورة",
        removePicture: "حذف الصورة",
        nameLabel: "الاسم",
        namePlaceholder: "اكتب اسمك",
        phoneLabel: "رقم الهاتف",
        phoneHint: "رقم هاتفك هو حسابك، ومش بيتغير",
        genderLabel: "النوع",
        genderPlaceholder: "اختر النوع",
        genderMale: "ذكر",
        genderFemale: "أنثى",

        brandTitle: "بيانات المتجر",
        brandSubtitle: "الاسم والرابط والوصف اللي بيشوفهم عملاؤك في المنيو",
        logoLabel: "شعار المتجر",
        coverLabel: "صورة الغلاف",
        coverHint: "صورة عريضة لمكانك، بتظهر خلف اسمك لما العميل يفتح تفاصيل المتجر",
        storeNameLabel: "اسم المتجر",
        slugLabel: "رابط المنيو",
        slugPlaceholder: "your-store",
        slugHint: "منيو متجرك هيكون على",
        slugLockedHint: "الرابط مطبوع على الـ QR Code بتاعك، فمش بيتغير من هنا",
        taglineLabel: "الجملة التعريفية",
        taglineHint: "سطر قصير تحت اسم متجرك — إنت مشهور بإيه",
        aboutLabel: "عن متجرك",
        aboutHint: "بيظهر لما العميل يضغط على اسم متجرك في المنيو. سطور النص بتتحفظ زي ما بتكتبها",
        typeLabel: "نوع المتجر",
        typePlaceholder: "اختر النوع",
        typeCafe: "كافيه",
        typeRestaurant: "مطعم",
        typeBoth: "كافيه ومطعم",
        typeOther: "آخر",
        readOnlyBadge: "للعرض فقط",

        menuColorLabel: "لون المنيو",
        menuColorHint: "اللون اللي بيشوفه عملاؤك في المنيو — الأزرار والأسعار والتمييز",
        menuColorReset: "رجوع للون الافتراضي",
        menuColorInvalid: "اكتب كود لون هيكس زي ‎#DD0D17",
        menuThemesLabel: "مظاهر المنيو",
        menuThemesHint: "لو سيبت مظهر واحد بس، المنيو هيفتح بيه دايماً من غير زرار تغيير المظهر",
        menuThemeLight: "فاتح",
        menuThemeDark: "داكن",

        preferencesTitle: "التفضيلات",
        preferencesSubtitle: "إعدادات خاصة بلوحة التحكم عندك بس",
        languageLabel: "لغة لوحة التحكم",
        languageArabic: "العربية",
        languageEnglish: "English",
        themeLabel: "مظهر لوحة التحكم",
        themeLight: "فاتح",
        themeDark: "داكن",
        comingSoon: "قريباً",
        themeHint: "الوضع الداكن جاي في تحديث قريب",

        saveButton: "حفظ التغييرات",
        savingButton: "جاري الحفظ...",
        cancelButton: "إلغاء",
        savedMessage: "تم الحفظ",
        noChangesHint: "مفيش تغييرات للحفظ",
    },
    storeLinks: {
        title: "التواصل والروابط",
        subtitle: "بتظهر لعملائك جوه المنيو، بنفس الترتيب ده",
        readOnlyBadge: "للعرض فقط",
        empty: "لسه مفيش روابط — ضيف رقم تليفون أو حساب سوشيال",
        addLabel: "إضافة رابط",
        editTitle: "تعديل الرابط",
        createTitle: "رابط جديد",
        typeLabel: "نوع الرابط",
        valueLabel: "القيمة",
        valuePhoneHint: "اكتب الرقم بكود الدولة، مثال ‎+20 109 015 2528",
        valueUrlHint: "الصق رابط صفحتك كامل",
        labelLabel: "نص الزر",
        labelHint: "سيبه فاضي عشان يستخدم اسم نوع الرابط",
        visibleLabel: "إظهار في المنيو",
        visibleHint: "اقفله عشان تحتفظ بالرابط من غير ما يظهر للعملاء",
        hiddenBadge: "مخفي",
        removeLabel: "حذف",
        moveUpLabel: "تحريك لأعلى",
        moveDownLabel: "تحريك لأسفل",
        saveLabel: "حفظ الرابط",
        cancelLabel: "إلغاء",
        valueRequired: "اكتب الرقم أو الرابط الأول",
        maxReached: "وصلت للحد الأقصى لعدد الروابط",
        autoSaveHint: "التغييرات هنا بتتحفظ أول بأول",
        types: {
            phone: "تليفون",
            whatsapp: "واتساب",
            facebook: "فيسبوك",
            instagram: "إنستجرام",
            tiktok: "تيك توك",
            website: "الموقع الإلكتروني",
            maps: "الموقع على الخريطة",
            custom: "رابط آخر",
        },
    },
    menuTheme: {
        title: "ثيم المنيو",
        subtitle: "الشكل اللي عملاؤك بيشوفوه لما يمسحوا الـ QR",
        readOnlyBadge: "للعرض فقط",
        activeBadge: "الحالي",
        currentLabel: "المنيو بتاعك",
        chooseLabel: "جرّب الثيم ده",
        customizeLabel: "تخصيص",
        openPreviewLabel: "افتح المعاينة كاملة",
        loadingThemes: "جاري تحميل الثيمات...",
        noThemes: "لا توجد ثيمات متاحة بعد",

        popupSubtitle: "اضبطه هنا، وبعدين طبّقه على المنيو",
        previewTitle: "معاينة المنيو",
        previewLoading: "جاري تجهيز المعاينة...",
        previewNote: "دي المنيو بتاعك أنت، بمنتجاتك",
        modesLabel: "المظهر",
        modesHint: "خلي واحد بس والمنيو هيفتح بيه دايماً، من غير اختيار للعميل",
        modeLight: "فاتح",
        modeDark: "داكن",
        layoutsLabel: "طريقة العرض",
        layoutsHint: "خلي واحدة بس وكل العملاء هيشوفوا المنيو بالشكل ده",
        layoutGrid: "شبكة",
        layoutList: "قائمة",
        colorLabel: "لون المنيو",
        colorHint: "اللون المميز في المنيو بتاعك — الأسعار والتفاصيل المهمة والتصنيف المفتوح",
        colorReset: "رجوع للافتراضي",
        colorInvalid: "اكتب كود لون هيكس زي ‎#DD0D17",
        noColorHint: "الثيم ده بيستخدم ألوانه الخاصة وبيتجاهل اللون المخصص",
        applyLabel: "طبّقه على منيوي",
        saveLabel: "حفظ التغييرات",
        savingLabel: "جاري الحفظ...",
        applyingLabel: "جاري التطبيق...",
        expandPreviewLabel: "ملء الشاشة",
        closePreviewLabel: "إغلاق المعاينة",
        orderHint: "أول اختيار بتحطه هو اللي المنيو هيفتح بيه",
        cancelLabel: "إلغاء",
        appliedMessage: "تم تحديث ثيم المنيو",
    },
    settingsOrdering: {
        title: "الطلب أونلاين",
        subtitle: "خلي عملاءك يبعتولك طلبهم من المنيو على طول",
        readOnlyBadge: "للعرض فقط",
        enableLabel: "استقبال الطلبات من المنيو",
        enableHint: "اقفله والمنيو يفضل منيو — مفيش أي حاجة عن الطلبات هتظهر",
        typesLabel: "الطلب رايح فين",
        typesHint: "اختر واحد على الأقل. التوصيل بيسأل عن العنوان، والطاولة بتسأل عن رقمها، والاستلام مش بيسأل عن حاجة",
        typeDelivery: "توصيل",
        typeTable: "على الطاولة",
        typePickup: "استلام من الفرع",
    },
    settingsLanguages: {
        title: "لغات المنيو",
        subtitle: "اللغات اللي عملاؤك يقدروا يقروا بيها المنيو",
        readOnlyBadge: "للعرض فقط",
        defaultBadge: "الافتراضية",
        setDefault: "اجعلها الافتراضية",
        remove: "إزالة",
        statusDefault: "المنيو بيفتح باللغة دي",
        statusEnabled: "متاحة في المنيو",
        statusDisabled: "مش متاحة في المنيو",
        translating: "بنترجم المنيو — خلصنا {done} من {total}",
        paused: "متوقفة لحد بكرة — خلصنا {done} من {total}، وهنكمل الباقي لوحدنا",
        finished: "تمت الترجمة",
        failed: "الترجمة وقفت قبل ما تخلص",
        needsWords: "{count} عنصر ماقدرناش نترجمهم — محتاجين صياغتك أنت",
        reviewNote: "دي ترجمة آلية. راجع وصف متجرك وعناوين فروعك — دول غالباً محتاجين صياغتك أنت.",
        add: "أضفها للمنيو",
        addConfirm: "هنترجم المنيو كله للغة دي تلقائياً. ممكن ياخد وقت، وتقدر تعدل أي حاجة بعدها.",
        addConfirmAction: "أضف وترجم",
        removeConfirm: "المنيو هيبطل يعرض اللغة دي. مش هيتحذف أي حاجة كتبتها — ضيفها تاني في أي وقت وترجع زي ما هي.",
        removeConfirmAction: "إزالة",
        cancel: "إلغاء",
        lastOneHint: "المنيو محتاج لغة واحدة على الأقل",
        hint: "العملاء بيشوفوا زرار تغيير اللغة لما تكون مفعّل أكتر من لغة",
    },
};

export default ar;
